import React from 'react';
import PropTypes from 'prop-types';
import { Layout, Card, Button, Space, Typography, Row, Col, Divider, Tag } from 'antd';
import { ArrowLeftOutlined, ThunderboltOutlined, MessageOutlined, FormOutlined } from '@ant-design/icons';
import styles from './InputModeSelection.module.css';

const { Title, Text, Paragraph } = Typography;

/**
 * InputModeSelection - Step 1 of wizard: Choose input mode
 *
 * Extracted from ReportWriterV2 to improve modularity
 */
const InputModeSelection = ({ selectedReport, onSelectMode, onBack }) => {
  return (
    <Layout className={styles.layout}>
      {/* Top Bar */}
      <div className={styles.topBar}>
        <Space className={styles.topBarSpace}>
          <Space>
            <Button size="small" icon={<ArrowLeftOutlined />} onClick={onBack}>
              Back to Report Type
            </Button>
            <Divider type="vertical" />
            <Text strong>
              {selectedReport === 'knowledge_gap' ? 'Knowledge Gap' : 'Key Decision'} - Choose Input Mode
            </Text>
          </Space>
        </Space>
      </div>

      {/* Content */}
      <div className={styles.contentArea}>
        <div className={styles.contentContainer}>
          <Title level={2}>How would you like to fill the report?</Title>
          <Paragraph type="secondary" className={styles.description}>
            Choose your preferred method for entering information.
          </Paragraph>

          <Row gutter={[24, 24]} justify="center">
            <Col xs={24} sm={8}>
              <Card
                hoverable
                onClick={() => onSelectMode('voice')}
                className={styles.voiceCard}
              >
                <Space direction="vertical" size="large" className={styles.voiceCardSpace}>
                  <ThunderboltOutlined className={styles.voiceIcon} />
                  <div className={styles.voiceContent}>
                    <Title level={4} className={styles.voiceTitle}>Voice Input</Title>
                    <Text type="secondary">
                      Speak your answers - AI formats them professionally
                    </Text>
                  </div>
                  <Tag color="blue">Fastest</Tag>
                </Space>
              </Card>
            </Col>

            <Col xs={24} sm={8}>
              <Card
                hoverable
                onClick={() => onSelectMode('assistant')}
                className={styles.assistantCard}
              >
                <Space direction="vertical" size="large" className={styles.assistantCardSpace}>
                  <MessageOutlined className={styles.assistantIcon} />
                  <div className={styles.assistantContent}>
                    <Title level={4} className={styles.assistantTitle}>Report Assistant</Title>
                    <Text type="secondary">
                      Type casually - AI converts to formal professional tone
                    </Text>
                  </div>
                  <Tag color="orange">AI-powered</Tag>
                </Space>
              </Card>
            </Col>

            <Col xs={24} sm={8}>
              <Card
                hoverable
                onClick={() => onSelectMode('direct')}
                className={styles.directCard}
              >
                <Space direction="vertical" size="large" className={styles.directCardSpace}>
                  <FormOutlined className={styles.directIcon} />
                  <div className={styles.directContent}>
                    <Title level={4} className={styles.directTitle}>Direct Edit</Title>
                    <Text type="secondary">
                      Type directly with full manual control
                    </Text>
                  </div>
                  <Tag color="green">Precision</Tag>
                </Space>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </Layout>
  );
};

InputModeSelection.propTypes = {
  selectedReport: PropTypes.oneOf(['knowledge_gap', 'key_decision']).isRequired,
  onSelectMode: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default InputModeSelection;
